module.exports = __webpack_public_path__ + "static/media/delete.a2f2898e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/delete.svg
// module id = 132
// module chunks = 0